/*=========================================================================================
	File Name: moduleAuthActions.js
	Description: Auth Module Actions
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import userJson from "../../../public/user.json";
import axios from "axios";
import router from '../../router'
import state from "../state"

export default {
	listStockForRole({ getters, commit, dispatch }, item) {
		const token = localStorage.getItem("fullFilmentTokenId")
		if (token === null || token == "null") { }
		else
			return new Promise((resolve, reject) => {
				if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin") {
					dispatch("listStockAll").then(response => {
						resolve(response);
					})
				}
				else if (state.AppActiveUser.ROLE == "Company") dispatch("listStockForCompany", state.AppActiveUser.companyid).then(response => {
					resolve(response);
				})
			})
	},
	updateStock({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.put(sistemAddress + "api/uzumservice/Stock/update/stocks", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					commit("DELETE_ITEM_STOCK", item.stockId)
					commit("ADD_ITEM_STOCK", item)
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	addStock({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/Stock/add/stocks", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					commit("ADD_ITEM_STOCK", item)
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	addStockList({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/Stock/add/stocks/list", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					//	commit("ADD_ITEM_STOCK", item)
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	pullStock({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/MarketPalce/pull/products/" + item.companyInfoId + "/" + item.depotId, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json); 
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				} else if (err.response.status == 400) { 
				}
				resolve(err.response);
			});
		});
	},
	listStock({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Stock/list/stocks", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOCK_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				} else if (err.response.status == 400) {
					commit("STOCK_LIST", []);
				}
				resolve(err.response);
			});
		});
	},
	listStockAll({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Stock/list/stocks/all", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {

				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOCK_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	listStockForCompany({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Stock/list/stocks/company/" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOCK_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					commit("STOCK_LIST", []);

					router.push("/login")
				}
			}).catch(err => {
				commit("STOCK_LIST", []);

				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	deleteStock({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/uzumservice/Stock/delete/stocks/" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					commit("DELETE_ITEM_STOCK", item)
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	addStockBarcode({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/Stock/add/stockbarcodes", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	updateStockBarcode({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.put(sistemAddress + "api/uzumservice/Stock/update/stockbarcodes", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	listStockBarcodes({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Stock/list/stockbarcodes", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOCK_BARCODES_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	listStockBarcodesForStock({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Stock/list/stockbarcode/stock/" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOCK_BARCODES_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	listStockBarcodesForStorehouse({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Stock/list/stockbarcode/depot/" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOCK_BARCODES_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				commit("STOCK_BARCODES_LIST", []);

				resolve(err.response);
			});;
		});
	},
	deleteStockBarcode({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/uzumservice/Stock/delete/stockbrcodes/" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
}
